@if (isLoading) {
  <korviu-loader></korviu-loader>
}
<form [formGroup]="referralForm" class="flex flex-col gap-4 md:gap-6 justify-start">
  <div class="flex justify-between gap-4">
    <korviu-input
      type="text"
      label="{{ 'referral.contactName' | translate }}"
      [control]="firstNameControl"
      [errorMessagesUnderField]="firstNameErrors"
      class="w-full"
      [showErrorMessagesUnderField]="true"
    ></korviu-input>
    <korviu-input
      type="text"
      label="{{ 'referral.lastName' | translate }}"
      [control]="lastNameControl"
      [errorMessagesUnderField]="lastNameErrors"
      class="w-full"
      [showErrorMessagesUnderField]="true"
    ></korviu-input>
  </div>
  <div>
    <korviu-input
      type="text"
      label="{{ 'referral.organizationNameOptional' | translate }}"
      [control]="orgNameControl"
      class="w-full"
      [showErrorMessagesUnderField]="true"
    ></korviu-input>
  </div>
  <div>
    <korviu-input
      type="phone"
      label="{{ 'referral.phoneNumber' | translate }}"
      maxLength="14"
      class="phone-number-field"
      [control]="phoneNumberControl"
      [phoneNumberPrefixControl]="phoneNumberPrefixControl"
      [removePlusFromPhoneCode]="true"
      [showErrorMessagesUnderField]="true"
      [errorMessagesUnderField]="phoneNumberErrors"
      (input)="onPhoneNumberInput($event)"
    ></korviu-input>
  </div>
  <div>
    <korviu-input
      type="text"
      label="{{ 'referral.email' | translate }}"
      [control]="emailControl"
      class="w-full"
      [showErrorMessagesUnderField]="true"
      [errorMessagesUnderField]="[{ errorCode: 'email', localizedMessage: 'validation.invalidEmail' }]"
    ></korviu-input>
  </div>
  <div class="flex flex-col gap-1">
    <korviu-input
      type="text"
      label="{{ 'referral.websiteLinkOptional' | translate }}"
      [control]="websiteLinkControl"
      class="w-full"
      [showErrorMessagesUnderField]="true"
    ></korviu-input>
    <span class="text-[#D3D3D3] text-[0.75rem]">{{ 'referral.example' | translate }}</span>
  </div>
  <div class="paragraph-medium medium">
    <span>{{ 'referral.whyWouldYourReferral' | translate }}</span>
  </div>
  <div>
    <korviu-textarea
      [control]="goodPartnerControl"
      [maxLength]="goodPartnerMaxLength"
      [maxCharacterCount]="goodPartnerMaxLength"
      placeholder="{{ 'referral.pleaseShareWithUsWhy' | translate }}"
    ></korviu-textarea>
  </div>
</form>
